import LegalShell from "./LegalShell";

export default function Terms() {
  return (
    <LegalShell eyebrow="Terms of Service" title="The fine print, gently.">
      <p>
        Welcome to StyleMe. These Terms govern your use of the website at stylenme.com and the
        StyleMe service (the "Service"). By using the Service you agree to these Terms.
      </p>

      <h2>1. The Service</h2>
      <p>
        StyleMe is an AI personal stylist that suggests outfits, hair, makeup and colours based on
        the portrait and preferences you provide. Recommendations are generated by AI and are
        provided "as is" for inspirational purposes — outcomes vary by photo quality, occasion,
        and personal taste.
      </p>

      <h2>2. Accounts</h2>
      <ul>
        <li>You must be 18+ to register.</li>
        <li>You're responsible for keeping your password secret. Tell us immediately at <a href="mailto:srichandrab@stylenme.com">srichandrab@stylenme.com</a> if you suspect unauthorised use.</li>
        <li>One person per account. Don't share your login.</li>
        <li>New members receive 3 complimentary AI-styled looks on signup. Paid plans unlock daily quotas and premium features.</li>
      </ul>

      <h2>3. Subscriptions & payments</h2>
      <ul>
        <li>Paid plans (Basic / Premium) are billed monthly via Razorpay in INR.</li>
        <li>Charges renew automatically only where explicit consent has been captured; otherwise each plan extends your benefits for 30 days per payment.</li>
        <li>Failed payments may suspend premium features until a successful charge is recorded.</li>
        <li>Refunds are governed by our <a href="/refund">Refund Policy</a>.</li>
      </ul>

      <h2>4. Your content</h2>
      <ul>
        <li>You retain all rights to the photo you upload. We process it in memory and never persist it (see <a href="/privacy">Privacy Policy</a>).</li>
        <li>You grant StyleMe a non-exclusive, royalty-free licence to display AI-generated previews of your portrait within your own account only.</li>
        <li>Don't upload photos you don't have the right to share, or photos of other people without consent.</li>
      </ul>

      <h2>5. Acceptable use</h2>
      <p>Don't use StyleMe to:</p>
      <ul>
        <li>Generate harmful, harassing, sexually explicit, or unlawful content.</li>
        <li>Attempt to reverse-engineer, scrape at scale, or interfere with the Service.</li>
        <li>Resell, sublicense or proxy access without written permission.</li>
      </ul>
      <p>We may suspend or terminate accounts that violate these rules.</p>

      <h2>6. Intellectual property</h2>
      <p>
        The StyleMe name, logo, copy and UI are owned by us. AI-generated outputs may be used by
        you for personal, non-commercial purposes. Commercial use requires written permission.
      </p>

      <h2>7. Disclaimers</h2>
      <p>
        The Service is provided "as is". We don't guarantee uninterrupted availability, the
        accuracy of recommendations, or specific outcomes (e.g., that a colour will look "great"
        on you). You're responsible for your own styling choices.
      </p>

      <h2>8. Limitation of liability</h2>
      <p>
        To the maximum extent permitted by law, StyleMe and its operators won't be liable for
        indirect, incidental or consequential damages arising from your use of the Service. Our
        total liability in any 12-month period is capped at the amount you paid us in that period.
      </p>

      <h2>9. Governing law</h2>
      <p>
        These Terms are governed by the laws of India. Courts of Bengaluru, Karnataka, India have
        exclusive jurisdiction.
      </p>

      <h2>10. Changes</h2>
      <p>
        We may update these Terms. We'll post material changes on this page and, where appropriate, notify by email.
      </p>

      <h2>11. Contact</h2>
      <p>
        Questions about these Terms: <a href="mailto:srichandrab@stylenme.com">srichandrab@stylenme.com</a>.
      </p>
    </LegalShell>
  );
}
